import type { CommittedJobNumberItem } from '../types';

export interface JobNumberPage {
  /** 現在ページに表示する確定済み行 */
  pageRows: CommittedJobNumberItem[];
  /** 範囲外にならないようクランプ済みの表示ページ番号 */
  currentPage: number;
  /** 絞り込み後の総件数（ページネーション表示用） */
  filteredCount: number;
  /** 検索ボックスを出すか（全確定件数基準） */
  showSearch: boolean;
  /** ページネーションを出すか（絞り込み後件数基準） */
  showPagination: boolean;
}

/**
 * 確定済み仕事No一覧に検索フィルタとページングを適用し、現在ページの表示状態を導出する。
 * 検索語は前後空白を無視し大文字小文字を区別せず部分一致する。
 */
export const selectJobNumberPage = (
  committedRows: CommittedJobNumberItem[],
  query: string,
  page: number,
  pageSize: number
): JobNumberPage => {
  const normalizedQuery = query.trim().toLowerCase();
  const filtered =
    normalizedQuery === ''
      ? committedRows
      : committedRows.filter(row => row.jobNumber.toLowerCase().includes(normalizedQuery));

  // 件数変化や検索でページが範囲外になっても破綻しないよう、表示ページは都度クランプする。
  const totalPages = Math.max(1, Math.ceil(filtered.length / pageSize));
  const currentPage = Math.min(page, totalPages);
  const pageRows = filtered.slice((currentPage - 1) * pageSize, currentPage * pageSize);

  return {
    pageRows,
    currentPage,
    filteredCount: filtered.length,
    // 検索ボックスは「全確定件数」基準で出し続ける（検索で1ページ以下に絞れても検索を続けられるように）。
    showSearch: committedRows.length > pageSize,
    // ページネーションは「絞り込み後の件数」基準で出す。
    showPagination: filtered.length > pageSize,
  };
};
